"use client";

import { useState, useRef } from "react";
import styled from "styled-components";
import { Icon } from "@churchofjesuschrist/eden-buttons";
import { Help } from "@churchofjesuschrist/eden-icons";
import EdenCallout from "@churchofjesuschrist/eden-callout";
import { spacing8, accentColorLink } from "@churchofjesuschrist/eden-style-constants";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const Callout = styled(EdenCallout).withConfig({
  componentId: "sc-10q14yd-0"
})(["padding:", ";"], spacing8);

/**
 * The `Tooltip` is used when a long description is needed to describe a form control.
 * @param {object} props - The component props
 * @param {string} [props.title] Advisory information for the tooltip's `Icon` button
 * @param {string} [props.calloutId] A unique identification for the tooltip's `Callout`
 * @param {"top" | "bottom"} [props.placement] Default location of the Tooltip. Will flip if there is not enough available space in that direction.
 * @param {React.ReactNode} props.children Content to render inside tooltip's `Callout`
 * @returns {React.ReactElement} The Tooltip component
 */
const Tooltip = ({
  children,
  title = "Additional Details",
  calloutId,
  placement = "top",
  ...props
}) => {
  const [open, setOpen] = useState(false);
  const iconRef = useRef(null);
  const openCallout = () => {
    setOpen(true);
  };
  const closeCallout = () => {
    setOpen(false);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Icon, {
      title: title,
      size: "small",
      ref: iconRef,
      onClick: openCallout,
      ...props,
      children: /*#__PURE__*/_jsx(Help, {
        color: accentColorLink
      })
    }), /*#__PURE__*/_jsx(Callout, {
      id: calloutId,
      open: open,
      onClickOutside: closeCallout,
      forRef: iconRef,
      placement: placement,
      children: children
    })]
  });
};
Tooltip.displayName = "Tooltip";
export default Tooltip;